import { Theme } from "@astryxdesign/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { hireosTheme } from "@shared/theme/hireos";

// Fonts are self-hosted in public/fonts.css (#117).
import "./styles.css";
import { router } from "./router";
import { initAnalytics } from "./lib/analytics";

// The in-app forward for links sent from the old `demo.hireos.co.nz` origin
// (#221) is gone: every path it covered is a token route, and token routes
// now 301 to app.hireos.co.nz from Firebase Hosting itself. That fires on
// every domain this site serves, `demo` included, before a byte of the app
// loads — one hop instead of two, and no frame where the page paints and
// analytics fires for a Customer who is about to leave.
initAnalytics();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <Theme theme={hireosTheme} mode="light">
      <RouterProvider router={router} />
    </Theme>
  </StrictMode>,
);
